import { css } from 'styled-components';
var getSizeCss = function getSizeCss(size) {
  if (typeof size === 'number') {
    return css(["\n      width: ", "px;\n      height: ", "px;\n    "], size, size);
  }
  var sizeCss = /*#__PURE__*/css(["\n    width: ", "px;\n    height: ", "px;\n  "], size.xs, size.xs);
  var prevSize = size.xs;
  if (size.sm && size.sm !== prevSize) {
    sizeCss = css(["\n      ", "\n      ", " {\n        width: ", "px;\n        height: ", "px;\n      }\n    "], sizeCss, function (_ref) {
      var theme = _ref.theme;
      return theme.breakpoints.up('sm');
    }, size.sm, size.sm);
    prevSize = size.sm;
  }
  if (size.md && size.md !== prevSize) {
    sizeCss = css(["\n      ", "\n      ", " {\n        width: ", "px;\n        height: ", "px;\n      }\n    "], sizeCss, function (_ref2) {
      var theme = _ref2.theme;
      return theme.breakpoints.up('md');
    }, size.md, size.md);
    prevSize = size.md;
  }
  if (size.lg && size.lg !== prevSize) {
    sizeCss = css(["\n      ", "\n      ", " {\n        width: ", "px;\n        height: ", "px;\n      }\n    "], sizeCss, function (_ref3) {
      var theme = _ref3.theme;
      return theme.breakpoints.up('lg');
    }, size.lg, size.lg);
  }
  return sizeCss;
};
export default getSizeCss;